<template>
  <div id="app">
    
      <router-view></router-view>
    
  </div>
</template>

<script lang="js">
    import settings from "@/backend/LocalSettings";

    export default {
        name: 'App',
        methods:
        {
            async check_version()
            {
                var local_version  = settings.version;
                var server_version = await this.post("version");
                
                if( local_version != server_version )
                {
                    this.$notify({
                        title: 'Atentie',
                        message: 'A aparut o noua versiune - <button onclick="window.location.reload()">Upgrade</button> ',
                        dangerouslyUseHTMLString: true,
                        type: 'warning',
                        duration: 0
                    });
                }
            },
            post: async function(url, args={}){
                var response = await this.$http.post(url, args );
                return response.bodyText;
            },
        },
        mounted()
        {
            //verificam daca exista o versiune mai noua
            this.check_version();
        }
    }
</script>



<style lang="less">
/* color palette from <https://github.com/vuejs/theme> */
body {
  background: url("assets/bg.jpg") no-repeat center;
  background-size: cover;
  min-height: 100vh;
  padding: 0;
  margin: 0;
  transition: color 0.5s, background-color 0.5s;
  line-height: 1.6;
  font-family: Avenir,Helvetica,Arial,sans-serif;
  font-size: 14px;
}
.el-form-item__label{
    padding: 0px!important;
    margin: 0px!important;
    line-height: 20px !important;
    color: black !important;
}
.el-table{
  color: black !important;
}
.my-dialog-class{
  .el-dialog{
    width: 95%;
    @media(min-width: 1024px){
      width: 95%;
    }
  } 
}
.my-small-dialog-class{
  .el-dialog{
    width: 80%;
    @media(min-width: 1024px){
      width: 40%;
      max-width: 520px;
    }
  }
}

.etichete-dialog-class{
  .el-dialog{
    width: 80%;
    @media(min-width: 1024px){
      width: 40%;
      max-width: 480px;
    }
  }
}

.info-dialog{
  background:#909399;
  color: white;
  text-transform: uppercase;
  padding: 5px;
  font-size: 10px;
  display: inline-block;
}
.btn-albastru{
      background: #409EFF;
      color: white !important;
      font-weight: bold;
      transition: 0.3s all linear;
      border-radius: 15px;
      a{
        color: white !important;
      }
      &:hover{
        background: blue;
  }
}

.el-form-item__label{
    font-size: 10px !important;
    font-weight: bold;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
    margin: 0 auto;
  }
  .el-table__expanded-cell{
    padding:0px !important;
  }

  .el-dialog__title{
    font-size: 20px;
  }
</style>
